import { render, staticRenderFns } from "./ROADMetricCard.vue?vue&type=template&id=2f877347&scoped=true&"
import script from "./ROADMetricCard.vue?vue&type=script&lang=js&"
export * from "./ROADMetricCard.vue?vue&type=script&lang=js&"
import style0 from "./ROADMetricCard.vue?vue&type=style&index=0&id=2f877347&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f877347",
  null
  
)

export default component.exports